









import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { ProductShowECResponseSchema } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const archiveBanner = computed(() => ({
      title: props.ecResponse.note_and_banner_text,
      image: props.ecResponse.note_and_banner_image,
      url: props.ecResponse.note_and_banner_url,
    }));
    return { archiveBanner };
  },
});
